var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { getVisitDetails } from '../services/CalendarService';
import { calendarKeys } from './queryKeys';
/**
 * On-demand hook for fetching full visit details when a modal is opened.
 *
 * Only fires when visitId is non-null — the modal passes its selected visit ID
 * and this hook fetches the complete data while the lightweight list entry
 * provides immediate display.
 */
export function useVisitDetails(visitId) {
    return useQuery({
        queryKey: calendarKeys.visitDetail(visitId !== null && visitId !== void 0 ? visitId : 0),
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const response = yield getVisitDetails(visitId);
            if (response.error) {
                throw new Error(response.error.message);
            }
            return response.data;
        }),
        enabled: visitId !== null,
        staleTime: 5 * 60 * 1000
    });
}
